import Label from "./Label.jsx";
import { theme } from "../../theme.js";

export default function Radio({ choice, formData, setFormData, required = false, trackInExtraOptions = false, disabled = false }) {
  const { id_bdd = "", name = "", label = name, choices = [], price = 0 } = choice || {};
  
  const onChange = (e) => {
    if (disabled) return;
    if (trackInExtraOptions) {
      setFormData({
        ...formData,
        extraOptions: {
          ...formData.extraOptions,
          [id_bdd]: { id: id_bdd, name: label, price:price, value: e.target.value },
        },
      });
    } else {
      setFormData({ ...formData, [name]: e.target.value });
    }
  };

  return (
    <div>
      <Label label={label} required={required} />
      <div style={styles(theme, disabled).radioGroup}>
        {choices.map((el, index) => {
          // Handle both simple values and objects with value/label
          const value = typeof el === 'object' ? el.value : el;
          const displayLabel = typeof el === 'object' ? el.label : el;
          
          return (
            <label key={value || index} style={{...styles(theme, disabled).radioLabel, opacity: disabled ? 0.6 : 1, cursor: disabled ? "not-allowed" : "pointer"}}>
              <input
                type="radio"
                name={name}
                value={value}
                checked={trackInExtraOptions ? formData.extraOptions[id_bdd]?.value === value : formData[name] === value}
                onChange={onChange}
                disabled={disabled}
                required
              />
              {displayLabel}
            </label>
          );
        })}
      </div>
    </div>
  );
}

const styles = (theme, disabled = false) => ({    
  radioGroup: {
    display: "flex",
    gap: theme.spacing.xl,
    flexWrap: "wrap",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xs,
    fontSize: theme.fonts.size.sm,
    cursor: "pointer",
    accentColor: theme.colors.bgDark,
  },
})